import { objectOf } from "@altostra/type-validations";
import { boolean } from "@altostra/type-validations/lib/primitives";

export const isPutCompaniesCompanyIdOauthMcpSettingsPartnerAppsEnabledResult = objectOf({
  partner_apps_enabled: boolean,
});
